export const RouteGetCategories_categoryId_DownloadCdtOrder =
  "/categories/:categoryId/download-cdt-order";

// The actual API response is a string (CSV data)
export type ResponseGetCategories_categoryId_DownloadCdtOrder = string;
